//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FoldBtn from './_fold_btn'
export default {
    props: {
        items: Array
    },
    components: {
        FoldBtn
    },
    data () {
        return {
            fold: true
        }
    },
    computed: {
        show_items () {
            if (this.fold) {
                return this.items.slice(0, 3)
            }
            return this.items
        }
    },
    methods: {
        openDetail (id) {
            wx.navigateTo({
                url: `/packageA/trade_data/auction/detail/main?id=${id}`
            })
        }
    }
}
